







































































import { cloneDeep } from 'lodash'
import { mapGetters } from 'vuex'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'

import { Profile, Post as StorePost } from '@/store/builder/types'
import WithBuilderStubProperties from '@/mixins/WithBuilderStubProperties'
import { ProfileStubState } from './BuilderProfile.vue'

import BuilderDefaultContainer from '@/components/builder/BuilderDefaultContainer.vue'
import BuilderDevice from '@/components/builder/BuilderDevice.vue'
import BuilderTooltip from '@/components/builder/BuilderTooltip.vue'
import BuilderButton from '@/components/builder/BuilderButton.vue'
import BuilderDeviceProfileStub from '@/components/builder/BuilderDeviceProfileStub.vue'
import BuilderCreatePostModal, {
  Post,
  Subscription,
} from '@/components/builder/BuilderCreatePostModal.vue'
import BuilderAddButton from '@/components/builder/BuilderAddButton.vue'
import BuilderDot from "@/components/builder/BuilderDot.vue"

@Component({
  components: {
    BuilderAddButton,
    BuilderCreatePostModal,
    BuilderButton,
    BuilderTooltip,
    BuilderDevice,
    BuilderDefaultContainer,
    BuilderDeviceProfileStub,
    BuilderDot
  },
  computed: {
    ...mapGetters('builder', { profile: 'getProfile',appType: 'getAppType' }),
  },
})
export default class BuilderProfileCreatePost extends Mixins(WithBuilderStubProperties) {
  @Prop({ required: true, type: Object }) readonly value!: ProfileStubState

  @Prop({ required: true, type: Number }) readonly step!: number

  profile!: Profile
  appType!: string
  
  processing = false

  newPost: Post | null = null

  editedPost: Post | null = null

  posts: Post[] = []
  static mapStorePost(p: StorePost): Post {
    return {
      ...p,
      type: p.attachments.length ? 1 : 0,
      attachments: p.attachments.map((f) => ({ id: f.id, file: f.url, mime: f.mime || null })),
      subscriptions: p.subscriptions.map((s) => ({ id: s.id, label: s.name })),
    }
  }

  get subscriptions(): Subscription[] {
    return (
      this.profile.subscriptions?.map(({ id, name }) => ({
        id,
        label: name,
      })) ?? []
    )
  }

  get isNextStepDisabled(): boolean {
    return !this.posts.length
  }

  @Watch('posts', { immediate: true, deep: true })
  onPostsChange(posts: Post[]): void {
    this.$emit('input', {
      posts: posts.map((p) => ({
        id: p.id,
        file: p.attachments[0]?.file ?? null,
        type: p.attachments[0]?.type ?? null,
        mime: p.attachments[0]?.mime ?? null,
      })),
    })
  }

  @Watch('profile.posts', { immediate: true })
  onProfilePostsChange(posts: StorePost[] | undefined): void {
    if (!posts) {
      return
    }

    this.posts = posts.map((p) => BuilderProfileCreatePost.mapStorePost(p))
  }

  async onPostEditClick(post: Post): Promise<void> {
    this.editedPost = cloneDeep(post)
  }

  async onPostAddClick(): Promise<void> {
    this.newPost = {
      id: -Number(Date.now().toString()),
      type: 0,
      text: '',
      subscriptions: [],
      attachments: [],
      comments: false,
    }
  }

  async onNewPostSubmit(post: Post): Promise<void> {
    this.posts = [...this.posts, { ...post }]
    this.newPost = null
  }

  async onEditedPostSubmit(post: Post): Promise<void> {
    this.posts = this.posts.map((p) => (p.id === post.id ? { ...post } : p))
    this.editedPost = null
  }

  onPostDelete(post: Post): void {
    this.posts = this.posts.filter(({ id }) => post.id !== id)
    this.editedPost = null
  }

  onChangePost({
    type,
    data,
  }: {
    type: 'newPost' | 'editedPost'
    data: { key: string; value: Post }
  }): void {
    if (type === 'newPost' && this.newPost) {
      this.$set(this.newPost, data.key, data.value)
    }

    if (type === 'editedPost' && this.editedPost) {
      this.$set(this.editedPost, data.key, data.value)
    }
  }

  async onNextClick(): Promise<void> {
    if (this.isNextStepDisabled) {
      return
    }

    this.processing = true
    try {
      await this.$store.dispatch('builder/setProfilePosts', {
        posts: this.posts.map((post) => {
          const resultPost = {
            id: post.id,
            text: post.text,
            promotional_page_id: post.promotional_page_id || null,
            subscriptionIds: post.subscriptions.map((s) => s.id),
            comments: post.comments,
            attachments: post.attachments.map((a) => (a.file instanceof File ? a.file : a.id)),
          }
          return resultPost
        }),
      })
      this.$emit('next')
    } catch ({ message }: unknown) {
      this.$toasted.error(String(message))
    }

    this.processing = false
  }

  async mounted(): Promise<void> {
    this.$emit('input', {
      highlight: 'posts',
      siteName: this.$t('create'),
      blurProfile: false,
      blurCover: false,
      blurSubscriptions: false,
      blurContentType: false,
    })
  }
}
